<template>
  <div>
    <tr v-for="[key, value] of Object.entries(items)" :key="key">
      <td>{{ key }}:</td>
      <td>{{ value }}</td>
    </tr>
  </div>
</template>

<script>
export default {
  name: "ProductObjects",
  props: {
    items: Object,
  },
  data: () => ({}),
  methods: {},
};
</script>
